/* unplugin-vue-components disabled */import { render } from "./MediaRecorder.vue?vue&type=template&id=548f981f&scoped=true&ts=true"
import script from "./MediaRecorder.vue?vue&type=script&lang=ts"
export * from "./MediaRecorder.vue?vue&type=script&lang=ts"

import "./MediaRecorder.vue?vue&type=style&index=0&id=548f981f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f981f"]])

export default __exports__